import { createAction } from 'redux-actions'

export const addHomePortType = createAction('ADD_HOME_PORT_TYPE')
